
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Login from '@/mixins/login';

@Component({})
export default class SearchCol extends mixins(Login) {}
